// @flow

const snippetMessageTypes = {
  ROUTE_CHANGE: 'ROUTE_CHANGE',
  DISPATCH_ACTION: 'DISPATCH_ACTION',
  SNIPPET_INIT: 'SNIPPET_INIT',
  TOGGLE_SELECTION: 'TOGGLE_SELECTION',
  PLACE_BET_START: 'PLACE_BET_START',
  PLACE_BET_SUCCESS: 'PLACE_BET_SUCCESS',
  PLACE_BET_FAILURE: 'PLACE_BET_FAILURE',
  WINDOW_PARAMS: 'WINDOW_PARAMS',
  SNIPPET_CONTENT_CHANGED: 'SNIPPET_CONTENT_CHANGED',
  SNIPPET_CHILD_CONTENT_CHANGED: 'SNIPPET_CHILD_CONTENT_CHANGED',
  SNIPPET_SINGLES_COUNT_CHANGED: 'SNIPPET_SINGLES_COUNT_CHANGED',
};

const partnerEvents = {
  MOUNT: 'mount',
  ROUTE_CHANGE: 'routeChange',
  TOGGLE_SELECTION: 'toggleSelection',
  PLACE_BET_START: 'placeBet.start',
  PLACE_BET_SUCCESS: 'placeBet.success',
  PLACE_BET_FAILURE: 'placeBet.failure',
};

const SB_CAROUSEL_TYPE = 'SportsbookCarousel';
const LIVE_PATH = '/live';
const CASINO_PATH = '/casino';
const PREMATCH_PATH = '/sportsbook';

module.exports = {
  SB_CAROUSEL_TYPE,
  LIVE_PATH,
  CASINO_PATH,
  PREMATCH_PATH,
  snippetMessageTypes,
  partnerEvents,
};
